import store from '../store'

let $ = window.$;

const messaggioAbbonatiGmPrimeRcordaSceltaCookieKey = 'CookieRicordaScelta_Abbonati_Servizio_GM_Prime';
const COD_TIPO_SERVIZIO_PRIME = 'Z3.010';

const formatterPrice_3digits = new Intl.NumberFormat('it-IT', {
    style: 'currency',
    currency: 'EUR',
    maximumFractionDigits:3,
    minimumFractionDigits: 3
    // These options are needed to round to whole numbers if that's what you want.
    //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
    //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
});

const formatterPrice_2digits = new Intl.NumberFormat('it-IT', {
    style: 'currency',
    currency: 'EUR',
    maximumFractionDigits:2,
    minimumFractionDigits: 2
    // These options are needed to round to whole numbers if that's what you want.
    //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
    //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
});

const formatterPrice_2digits_noCurrency = new Intl.NumberFormat('it-IT', {
    maximumFractionDigits:2,
    minimumFractionDigits: 2
});

const formatterPrice_3digits_noCurrency = new Intl.NumberFormat('it-IT', {
    maximumFractionDigits:3,
    minimumFractionDigits: 3
});

const formatterNumber = new Intl.NumberFormat('it-IT');

function piceToString(price, numberOfDigits){
    if(numberOfDigits <= 2){
        return formatterPrice_2digits.format(price);
    }
    else{
        return formatterPrice_3digits.format(price);
    }
}

function piceToString_noCurrency(price, numberOfDigits){
    if(numberOfDigits <= 2){
        return formatterPrice_2digits_noCurrency.format(price);
    }
    else{
        return formatterPrice_3digits_noCurrency.format(price);
    }
}

function numberToString(number){
    return formatterNumber.format(number);
}

function dateToString(dateString){
    var options = { year: 'numeric', month: '2-digit', day: '2-digit' };
    let date = new Date(dateString);
    return date.toLocaleDateString("it-IT", options);
}

function dateEvasioneToString(date){
    var options = { year: 'numeric', month: 'long', day: '2-digit' };
    //let date = new Date(dateString);
    return date.toLocaleDateString("it-IT", options);
}

function roundNumberWithPrecision(number, precision){
    return +number.toFixed(precision);
    // Note the plus sign that drops any "extra" zeroes at the end.
    // It changes the result (which is a string) into a number again (think "0 + foo"),
    // which means that it uses only as many digits as necessary.
}

function showLoginPopup_v2(returnUrl) {

    var res = window.dnnModal.show("/Login?popUp=true&returnurl=" + returnUrl, true /*showReturn*/, 550, 1200, true, "");
    $('iframe#iPopUp')[0].onload = function () {
        $('iframe#iPopUp')[0].contentDocument.body.style.overflow = 'scroll';
    };
 
    return res;
}

const CODICE_PAGAMENTO_PAYPAL = "PP.010";
const tipoPagamentoEnum = Object.freeze({
    BBA: 1,    // Pagamento Anticipato (ex ListaPagamentiEmailBba)
    CAS: 2,    // Contrassegno (ex ListaPagamentiEmailCas)
    RIBA: 3,   // Pagamento Posticipato (ex ListaPagamentiEmailRiba)
    PayPal: 4  // Pagamento via PayPal
});

const tipoCorriereConsts = Object.freeze({
    RitiraCliente: "02"
});

const tipoTrasportoConsts = Object.freeze({
    PortoAssegnato: "AS",
    PortoFrancoConAddebito: "FA",
    PortoFrancoPrime: "FT",
});

const tipoCarrelloEnum = Object.freeze({
    CarrelloNeutro: 0,
    CarrelloPersonalizzato: 1,
    CarrelloFullCustom: 2,
    CarrelloServizi: 3,
});

const stepCarrelloEnum = Object.freeze({
    //PRECARRELLO_STEP_1: 0,
    PRECARRELLO_STEP_2: 1,
    CARRELLO_STEP_1: 2,
    CARRELLO_STEP_2: 3
});

const statoServizioEnum = Object.freeze({
    NonDisponibile: 0,
    Disponibile_NonAttivo: 1,
    Disponibile_Acquistato_NonAttivo: 2,
    Disponibile_Acquistato_Attivo: 3,
  });

const tipoImmagineEnum = Object.freeze({
    Main: 0,
    Details: 1,
    Colors: 2,
    PianoTaglie: 5,
});

function seMostrareMessaggioPromozionaleTipoServizio(tipoServizio){
    let messageAlreadyShown = store.state.messagePrimeAlreadyShown;
    if(messageAlreadyShown) return false;

    var listaServiziByCodTipoServizio = 
        store.state.loggedUserInfo.CustomerData.ServiziAssociati.filter(x => x.CodiceTipoServizio == tipoServizio);

    var result = listaServiziByCodTipoServizio.some(x => x.Stato ==  statoServizioEnum.Disponibile_NonAttivo) &&
                 listaServiziByCodTipoServizio.every(y => y.Stato != statoServizioEnum.Disponibile_Acquistato_NonAttivo &&
                                                          y.Stato != statoServizioEnum.Disponibile_Acquistato_Attivo);
    return result;
}

function seUtenteCorrenteConTipoServizioAttivo(tipoServizio){
    if(!store.state.loggedUserInfo || 
       !store.state.loggedUserInfo.CustomerData ||
       !store.state.loggedUserInfo.CustomerData.ServiziAssociati) {
        return false;
    }
    
    var result = store.state.loggedUserInfo?.CustomerData?.ServiziAssociati?.some(x =>
        x.CodiceTipoServizio == tipoServizio &&
        x.Stato == statoServizioEnum.Disponibile_Acquistato_Attivo &&
        x.DataScadenza && Date.parse(x.DataScadenza) > new Date()) ?? false;
    return result;
}

export default{
    piceToString,
    piceToString_noCurrency,
    numberToString,
    dateToString,
    dateEvasioneToString,
    roundNumberWithPrecision,
    showLoginPopup_v2,
    seMostrareMessaggioPromozionaleTipoServizio,
    seUtenteCorrenteConTipoServizioAttivo,
    messaggioAbbonatiGmPrimeRcordaSceltaCookieKey,
    COD_TIPO_SERVIZIO_PRIME,
    stepCarrelloEnum,
    tipoCarrelloEnum,
    tipoTrasportoConsts,
    tipoCorriereConsts,
    tipoPagamentoEnum,
    tipoImmagineEnum,
    CODICE_PAGAMENTO_PAYPAL
}